import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { WHATSAPP_NUMBER } from "../lib/api";

export const WhatsAppFloat = () => {
  const open = () => {
    const msg = "¡Hola Ciudad Garaje! Quiero más información.";
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <button
      onClick={open}
      aria-label="Escríbenos por WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60] w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-black flex items-center justify-center shadow-lg shadow-black/40 hover:scale-110 hover:bg-[#20bd5a] transition-transform"
      style={{ transitionProperty: "transform, background-color" }}
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" style={{ animationDuration: "2.5s" }} />
      <WhatsappLogo size={30} weight="fill" className="relative" />
    </button>
  );
};
